<template>
  <refonte-modal
    v-bind:show="props.show"
    class="!max-w-[704px]"
    v-on:close="close">
    <template v-slot:modalHeader> <h1>Droit de rétractation</h1> </template>
    <template v-slot:modalBody>
      <div v-if="formation">
        <div v-if="formation?.moduleElearning?.dateFinRetractation">
          En tant que particulier, vous pouvez exercer votre droit de
          rétractation jusqu'au
          <b>{{ formation.moduleElearning.dateFinRetractation }}</b
          >.
        </div>
        <br />
        <div class="warning-card">
          <IconWarning20 />
          Cette action entraînera l'annulation définitive de votre inscription.
        </div>
        <br />
        <refonte-checkbox
          label="Je souhaite annuler mon inscription et exercer mon droit de rétractation."
          v-bind:value="checked"
          v-on:input="(value) => setCheck(value)" />
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        variant="text"
        v-bind:on_click="close">
        Annuler
      </refonte-button>
      <refonte-button
        v-bind:on_click="() => confirm(formation)"
        v-bind:disabled="!checked">
        Je me rétracte
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import { ref } from 'vue';
  import IconWarning20 from '@/assets/img/refonte/icons/information/icon-warning-sign-20.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteCheckbox from '@/components/refonte/inputs/refonte-checkbox.vue';
  import { RetractationFormation } from '@/types/participant/formations-types';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      formation?: RetractationFormation;
      confirm: Function;
    }>(),
    {
      class: ''
    }
  );

  function close() {
    props.on_close();
  }
  const checked = ref<boolean>(false);
  const setCheck = (value: boolean) => {
    checked.value = value;
  };
</script>

<style lang="scss" scoped>
  .warning-card {
    @apply flex items-center bg-yellow-100 p-3 text-yellow-800;
  }
</style>
